import { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import { FailureSeverity } from '../business-error';
import { supportEmail } from '../../../constants/utils';

interface StyleProps {
  severity: FailureSeverity;
}

const useStyles = makeStyles((theme: Theme) => ({
  linkColor: {
    color: ({ severity }: StyleProps) => {
      if (severity === 'error') return theme.palette.error.dark;
      if (severity === 'warning') return theme.palette.warning.dark;

      return undefined;
    }
  }
}));

interface Props {
  severity: FailureSeverity;
}

const SupportMail = ({ severity }: Props) => {
  const classes = useStyles({ severity });

  return (
    <b>
      <a className={classes.linkColor} href={`mailto: ${supportEmail}`}>
        {supportEmail}
      </a>
    </b>
  );
};

export default memo(SupportMail);
